module.exports = __webpack_public_path__ + "static/polycli-93b97543d58ed69a24c1c647f783d2a4.png";